<template>
  <div class="memberList">
    <v-card class="cardWrap">
      <CardTitle title="管理ユーザー一覧" />
      <v-data-table
        :headers="headers"
        :items="desserts"
        hide-default-footer
        class="elevation-1"
        sort-by="id">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              class="mr-3"
              v-model="search.name"
              append-icon="mdi-account-search"
              label="氏名"
              single-line
              hide-details
            />
            <v-select
              class="mr-3"
              :items="golf_courses"
              item-value="golf_code"
              item-text="golf_name"
              v-model="search.golf_code_val"
              label="ゴルフ場を選択"
              hide-details
            />
            <v-btn :disabled="btn[1].isActive" color="primary" dark class="ml-5" v-on:click="clickSearch">検索</v-btn>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon @click="AdminInfoSetting(true, item)">mdi-cog</v-icon>
        </template>
      </v-data-table>
      <v-pagination
        class="my-2"
        v-model="page"
        :length="pageCount"
        :total-visible="7"
        @input="clickPagination"
      ></v-pagination>
    <v-spacer></v-spacer>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="btn[2].isActive" color="blue darken-4" text @click="AdminAddSetting(true)">追加</v-btn>
    </v-card-actions>
    </v-card>
    <AdminMember
        :btn="btn"
        ref="AdminMemberView"
        @refresh-event="initialize" />
  </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import AdminMember from './AdminMember';
import { authorityMixin } from '@/views/authorityMixin';

import {
    GET_ADMIN_MEMBER_LIST,
    GET_GOLF_COURSE_LIST } from '../../constants/admin';

export default {
    components: {
        CardTitle,
        AdminMember
    },
    mixins: [
        authorityMixin
    ],
    data () {
        return {
            page: 1,
            pageCount: 0,
            // 検索キーワード
            search: {
                user_name: '',
                golf_code_val: ''
            },
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: 'No', value: 'user_id' },
                { text: '氏名', align: 'left', sortable: false, value: 'full_name' },
                { text: 'ゴルフ場', value: 'golf_name', sortable: false },
                { text: '権限', value: 'code_name', sortable: false },
                { text: '詳細', align: 'center', value: 'action', sortable: false }
            ],
            // 区分選択のセレクトエリアの表示値
            golf_courses: [],
            // 区分選択で選択した値
            golf_code_val: null,
            // ゴルフグループ process.env.VUE_APP_GROUP_CODEの値
            golf_groups_val: '',
            begin_row: 0,
            limit_rows: 10,
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true },
                { element_id: '003', element_name: '変更', isActive: true },
                { element_id: '004', element_name: '削除', isActive: true }
            ],
            vue_id: 'SCR0009'
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         *---------------------------------------------- */
        async initialize () {
            this.admin = await this.getLoginAdmin();
            this.getAuthorityList();
            this.getMember();
            this.golf_groups_val = process.env.VUE_APP_GROUP_CODE;
            this.getGolfCourse();
        },
        /** --------------------------------------------
         * 会員情報を取得
         * -------------------------------------------- */
        async getMember () {
            try {
                await this.$apollo
                    .mutate({
                        fetchPolicy: 'no-cache',
                        mutation: GET_ADMIN_MEMBER_LIST,
                        variables: {
                            full_name: this.search.name,
                            golf_code: this.search.golf_code_val,
                            begin_row: this.begin_row,
                            limit_rows: this.limit_rows
                        }
                    })
                    .then(res => {
                        const lists = res.data.GetAdminMemberList.AdminMemberList;
                        const count = res.data.GetAdminMemberList.count;
                        this.pageCount = Math.ceil(count / 10);
                        lists.forEach(list => {
                            list.full_name = list.family_name + ' ' + list.given_name;
                        });
                        this.desserts = lists;
                    });
            } catch (error) {
                this.error = error;
            }
        },
        /** --------------------------------------------
         * ゴルフグループ情報を取得
         * -------------------------------------------- */
        getGolfCourse () {
            this.$apollo
                .mutate({
                    fetchPolicy: 'no-cache',
                    mutation: GET_GOLF_COURSE_LIST,
                    variables: { golf_group_code: this.golf_groups_val }
                })
                .then(res => {
                    this.data = res.data.golfCourseListByAdminList;
                    this.golf_courses_val = this.data[0].golf_code;
                    // セレクトボックスに空欄を追加
                    this.golf_courses.push('');
                    this.data.forEach(data => {
                        this.golf_courses.push(data);
                    });
                    // 管理者用のitemを追加
                    this.golf_courses.push({ golf_code: process.env.VUE_APP_ADMIN_GOLF_CODE, golf_name: 'その他' });
                })
                .catch(error => {
                    this.result = 0;
                    this.error = error;
                });
        },
        /** ----------------------------------------------
         * 管理ユーザー追加ボタン押下時の処理
         * @val 子画面に渡すモーダル表示制御値
         * ---------------------------------------------- */
        AdminAddSetting: function (val) {
            this.$refs.AdminMemberView.ModalControl(val, 'addMode');
        },
        /** ----------------------------------------------
         * 管理ユーザー詳細ボタン押下時の処理
         * @val 子画面に渡すモーダル表示制御値
         * @user_id 押下した行のID
         * ---------------------------------------------- */
        AdminInfoSetting: function (val, userId) {
            this.$refs.AdminMemberView.InfoAdminModal(val, userId, 'checkMode');
        },
        clickPagination: function () {
            this.begin_row = this.page * 10 - 10;
            this.getMember();
        },
        clickSearch: function () {
            this.page = 1;
            this.begin_row = 0;
            this.getMember();
        }
    }
};
</script>
